import { useAuth } from '@/hooks/use-auth'
import { BenefitsSignupPage } from '@/pages/benefits/benefits-signup'
import type { ComponentType } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { AccessGuard } from './access-guard'

// `/benefits` is two pages sharing one path: the support hub for signed-in
// users, and the public severance claim form for employees who do not have an
// account yet. The hub is registered first in embraceRouter, so it matches
// first and this guard used to bounce an anonymous visitor to /login -- a dead
// end, because claiming is how that employee would get credentials at all.
// Serve the claim page for that one path instead; every other protected path
// still redirects.
const ANONYMOUS_ROUTES: Record<string, ComponentType> = {
  '/benefits': BenefitsSignupPage,
}

export function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="animate-pulse text-lg">Loading...</div>
      </div>
    )
  }

  if (!isAuthenticated) {
    const AnonymousPage = ANONYMOUS_ROUTES[location.pathname]
    if (AnonymousPage) {
      return <AnonymousPage />
    }
    return <Navigate to="/login" replace />
  }

  return (
    <AccessGuard
      routeId="participant.root"
      deniedTitle="Participant access required"
      deniedMessage="This account is valid, but it is not enrolled in a Pelgo participant program."
    >
      <Outlet />
    </AccessGuard>
  )
}
